(() => {
  /* =========================================================
     LIDOR BAR - Size pills
     1) Show variants when card is in viewport (IntersectionObserver)
     2) Arrow (.lb-size-more) expands/collapses
     3) NEW:
        - Default: show only 3 sizes (CSS should hide 4+ when NOT .is-expanded)
        - If a product has 3 sizes or less -> hide the arrow area completely
          (adds .no-more on .lb-size-pills)
     ========================================================= */

  const CARD_SELECTORS = [
    '.product-card',
    'product-card',
    '.product-item',
    '.grid__item'
  ];

  const VARIANTS_WRAPPER_SELECTOR = '.lb-size-pills';
  const PILL_SELECTOR = '.lb-size-pill';
  const MORE_BUTTON_SELECTOR = '.lb-size-more';

  const getCards = () => {
    for (const sel of CARD_SELECTORS) {
      const found = document.querySelectorAll(sel);
      if (found && found.length) return Array.from(found);
    }
    return [];
  };

  const hasVariantsBlock = (card) => !!card.querySelector(VARIANTS_WRAPPER_SELECTOR);

  // ✅ Add/remove .no-more based on how many pills exist
  const markNoMoreState = (card) => {
    const box = card.querySelector(VARIANTS_WRAPPER_SELECTOR);
    if (!box) return;

    const pillsCount = box.querySelectorAll(PILL_SELECTOR).length;

    // If 3 or less -> no arrow + no bottom "bump"
    if (pillsCount <= 3) {
      box.classList.add('no-more');
      box.classList.remove('is-expanded');
      const btn = box.querySelector(MORE_BUTTON_SELECTOR);
      if (btn) btn.setAttribute('aria-expanded', 'false');
    } else {
      box.classList.remove('no-more');
    }
  };

  const initIntersection = () => {
    const cards = getCards().filter(hasVariantsBlock);
    if (!cards.length) return;

    // mark initial state
    cards.forEach(markNoMoreState);

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const card = entry.target;

          if (entry.isIntersecting) {
            card.classList.add('show-variants');
            // themes sometimes re-render: re-check count when it appears
            markNoMoreState(card);
          } else {
            card.classList.remove('show-variants');

            // optional: collapse when leaving viewport
            const box = card.querySelector(VARIANTS_WRAPPER_SELECTOR);
            if (box) box.classList.remove('is-expanded');
          }
        });
      },
      { threshold: 0.25 }
    );

    cards.forEach((card) => obs.observe(card));
  };

  const initArrowClick = () => {
    // Capture phase helps when the whole card is a link and tries to steal the click
    document.addEventListener(
      'click',
      (e) => {
        const btn = e.target.closest(MORE_BUTTON_SELECTOR);
        if (!btn) return;

        const box = btn.closest(VARIANTS_WRAPPER_SELECTOR);
        if (!box) return;

        // If no-more, do nothing
        if (box.classList.contains('no-more')) return;

        // stop navigation / card click
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        box.classList.toggle('is-expanded');

        // accessibility state
        const isOpen = box.classList.contains('is-expanded');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      },
      true
    );
  };

  const init = () => {
    initIntersection();
    initArrowClick();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
